import { RtwMaintenanceRequest } from '../types/return-to-work'

/**
 * Converts boolean to string representation for radio buttons
 */
export const boolToString = (val: boolean | string): string => {
  if (typeof val === 'string') {
    return val === 'Yes' ? 'Yes' : 'No'
  }
  return val ? 'Yes' : 'No'
}

/**
 * Converts string to boolean for form processing
 */
export const stringToBool = (val: string): boolean => val === 'Yes'

/**
 * Validates RTW form data
 */
export const validateRtwForm = (data: RtwMaintenanceRequest): string[] => {
  const errors: string[] = []

  if (!data.returnDate) {
    errors.push('Return date is required')
  }

  if (data.proceduresFollowed === undefined || data.proceduresFollowed === null) {
    errors.push('Please specify if procedures were followed')
  }

  if (data.recurrent === undefined || data.recurrent === null) {
    errors.push('Please specify if this absence was recurrent')
  }

  if (data.companyAction === undefined || data.companyAction === null) {
    errors.push('Please specify if company action is needed')
  }

  return errors
}

/**
 * Determines if RTW can be printed based on absence status
 */
export const canPrintRtw = (absenceStatus: string, hasValidRtw: boolean): boolean => {
  const normalizedStatus = absenceStatus?.toLowerCase().replaceAll(' ', '') || ''
  return normalizedStatus === 'awaitingrtw' || hasValidRtw
}

/**
 * Calculates total hours lost from absence days
 */
export const calculateTotalHoursLost = (absenceDays: any[]): number =>
  absenceDays.reduce((total, day) => total + day.hoursLost, 0)

/**
 * Calculates total sick pay hours used
 */
export const calculateTotalSickPayHours = (absenceDays: any[]): number =>
  absenceDays.reduce((total, day) => total + (day.sickHoursToBePaid || 0), 0)